import { render, staticRenderFns } from "./DebtLimitFInfo.vue?vue&type=template&id=4bf573fc&"
import script from "./DebtLimitFInfo.vue?vue&type=script&lang=js&"
export * from "./DebtLimitFInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports